import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {Operation} from '../../../operation/operations/operation.model';
import {UserPartner} from '../../../users/users-partner/user-partner.model';
import {OperationUtils} from '../../utils/OperationUtils';
import {PlatformConfig} from '../../../app-loader/platform-config';
import {ConfigLoaderService} from '../../../app-loader/config-loader.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-show-operation-block',
  templateUrl: './show-operation-block.component.html',
  styleUrls: ['./show-operation-block.component.scss']
})
export class ShowOperationBlockComponent implements OnInit, OnChanges {

  @Input('operation') operation: Operation;
  @Input('userOperatorPartner') userOperatorPartner: UserPartner;
  @Input('operationCostLoading') operationCostLoading: boolean;
  @Input('receivingAmountLoading') receivingAmountLoading: boolean;
  @Input('operationType') operationType: string;
  @Input("operationMFS") operationMFS:any;

  sourceCurrencyShortName: string = '';
  targetCurrencyShortName: string = '';

  platformConfig: PlatformConfig;
  isCardExpire = false;
  constructor(public configLoaderService: ConfigLoaderService, public datePipe: DatePipe) {
    this.platformConfig = this.configLoaderService.getPlatformConfig();
  }

  ngOnInit() {
   
    let cardExpire
    if(this.operation.customer){
       cardExpire = this.datePipe.transform(this.operation.customer.cardExpiration,'yyyy-MM-dd');
        this.sourceCurrencyShortName = this.operation.customer.account && this.operation.customer.account.monetaryArea ? this.operation.customer.account.monetaryArea.currencyShortName : '';
    }
     
    let today = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    if(cardExpire < today){
      this.isCardExpire = true;
   
    }else {
     
    }
    
   
    this.updateTargetCurrencyShortName();
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log(changes);
    this.updateTargetCurrencyShortName();
    if (changes.hasOwnProperty('operation')) {
      this.operation = changes.operation.currentValue;
    }
    if (changes.hasOwnProperty('operationType')) {
      this.operationType = changes.operationType.currentValue;
    }
    if (changes.hasOwnProperty('userOperatorPartner')) {
      this.userOperatorPartner = changes.userOperatorPartner.currentValue;
    }
    if (changes.hasOwnProperty('operationCostLoading')) {
      this.operationCostLoading = changes.operationCostLoading.currentValue;
    }
    if (changes.hasOwnProperty('receivingAmountLoading')) {
      this.receivingAmountLoading = changes.receivingAmountLoading.currentValue;
    }
    if(changes.hasOwnProperty('operationMFS')){
      this.operationMFS = changes.operationMFS.currentValue;
    }
  }

  updateTargetCurrencyShortName() {
    if (this.operation.receiver !== null && this.operation.receiver !== undefined) {
      if (this.operation.receiver.account !== null && this.operation.receiver.account !== undefined) {
        this.targetCurrencyShortName = this.operation.receiver.account.monetaryArea.currencyShortName;
      }
    }
  }

  isAmountCredited() {
    return OperationUtils.isOperationAmountCredited(this.operation);
  }

  isAmountDebited() {
    return OperationUtils.isOperationAmountDebited(this.operation);
  }

}



// WEBPACK FOOTER //
// C:/Users/DENISE/Documents/IT4U/web-callcenter/src/app/shared/components/show-operation-block/show-operation-block.component.ts